<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import TimeOffCreate from '../../../../time-off/components/TimeOffCreate.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <TimeOffCreate />
</template>